import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <AboutSection />
        <TopicsSection />
        <RankingSection />
        <FAQSection />
        <UpdatesSection />
        <CommentsSection />
        <AppSection />
        <MediaSection />
        <FeaturesSection />
        <CardsSection />
        <IndexSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}